import React from 'react'

const FALogo = ({ ...props }) => (
  <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 200" {...props}>
    <g>
      <path
        fill="#e21412"
        d="M153,44.09c-5.81-5.81-29.63-8.13-58.1,1.16-27.31,8.72-46.48,25-48.8,35.44-4.07,15.69,24.4,43,30.21,48.23,8.13,7.55,36,31.37,49.38,27.3,8.72-2.9,25.57-21.49,32.54-51.7C164.65,74.3,159.42,49.9,153,44.09Zm-4.65,50.55c-4.07,18-13.94,29.05-19.17,30.79-7.56,2.33-24.4-11.62-29.05-16.27-3.49-2.9-20.34-19.17-18-28.47C83.89,74.3,94.93,65,111.2,59.78c16.85-5.23,30.79-4.07,34.28-.58C149.54,62.68,152.45,77.21,148.38,94.64Z"
      />
      <polygon
        fill="#1a3374"
        points="470.83 83.02 488.26 83.02 501.63 122.53 515.57 83.02 531.84 83.02 510.34 137.63 491.17 137.63 470.83 83.02"
      />
      <path
        fill="#1a3374"
        d="M722.41,112.65c0,19.17-10.46,26.14-29,26.14s-29.05-7-29.05-24.4V82.44H680v31.37c0,9.88,4.65,14,13.37,14,10.45,0,13.36-6.4,13.36-16.27V83h15.69Z"
      />
      <polygon
        fill="#1a3374"
        points="595.17 83.02 615.5 83.02 639.9 122.53 639.9 122.53 639.9 83.02 653.85 83.02 653.85 137.63 633.51 137.63 609.11 98.13 608.53 98.13 608.53 137.63 595.17 137.63 595.17 83.02"
      />
      <polygon
        fill="#1a3374"
        points="537.65 83.02 584.13 83.02 584.13 94.06 553.34 94.06 553.34 104.52 582.39 104.52 582.39 115.56 553.34 115.56 553.34 126.59 584.71 126.59 584.71 137.63 537.65 137.63 537.65 83.02"
      />
      <polygon
        fill="#1a3374"
        points="731.7 83.02 731.7 137.63 778.76 137.63 778.76 126.59 747.39 126.59 747.39 115.56 776.44 115.56 776.44 104.52 747.39 104.52 747.39 94.06 778.18 94.06 778.18 83.02 731.7 83.02"
      />
      <polygon
        fill="#1a3374"
        points="182.08 83.02 223.33 83.02 223.33 93.48 198.35 93.48 198.35 106.26 221.59 106.26 221.59 116.72 198.35 116.72 198.35 137.63 182.08 137.63 182.08 83.02"
      />
      <rect fill="#1a3374" x="232.04" y="83.02" width="16.27" height="54.61" />
      <g>
        <path
          fill="#1a3374"
          d="M276.78,106.26h5.81c3.49,0,5.23,0,6.39-.58,3.49-1.16,4.07-4.65,4.07-6.39,0-7-6.39-7-11-7H276.2v14ZM261.09,83h26.73c10.46,0,14.53.58,18,4.07,1.74,1.74,4.07,4.64,4.07,10.45s-2.33,8.72-5.23,9.88c-3.49,2.32-7,2.32-8.72,2.91v.58c11,.58,11.62,5.23,13.37,13.36.58,3.49,1.16,9.88,2.9,13.36H294.79c-1.16-3.48-1.16-7.55-1.74-12.2-.58-6.39-1.16-8.71-8.13-8.71h-7v21.49H261.68L261.09,83Z"
        />
        <path
          fill="#1a3374"
          d="M332.56,120.2c0,2.33,0,8.72,9.87,8.72,1.17,0,8.72,0,8.72-6.39,0-2.33-1.16-4.07-5.23-5.23l-14.52-3.49c-4.07-1.16-14.53-3.48-14.53-15.1,0-8.72,7-16.85,24.4-16.85,22.66,0,23.82,11.62,23.82,17.43H348.82c0-1.75,0-7.56-7.55-7.56-4.65,0-7.55,2.33-7.55,5.81,0,4.07,3.49,5.23,5.81,5.81l11,2.91c7.55,1.74,16.85,4.07,16.85,15.69,0,12.2-11,17.43-25.57,17.43-5.81,0-15.68-1.17-20.91-6.4-4.07-4.64-4.07-9.87-4.65-12.2h16.27Z"
        />
      </g>
      <polygon
        fill="#1a3374"
        points="386.59 94.06 369.16 94.06 369.16 83.02 420.87 83.02 420.87 94.06 402.86 94.06 402.86 137.63 386.59 137.63 386.59 94.06"
      />
      <path
        fill="#1a3374"
        d="M451.08,116.72l-7.55-23.24h0l-8.14,22.66,15.69.58ZM434.23,83H454l22.65,54.61h-18l-4.06-11H431.33l-4.07,11H411Z"
      />
    </g>
  </svg>
)

export default FALogo
